import { IBasket } from '../baskets/basket';
import { IContact } from '../contact/contact';
import { IMember } from '../member/member';
import { IResult } from '../results/result';
import { IPaginatedList, ITotalRow } from '../structure';

export enum AddressType {
  MAIN = 0, // Main address
  INVOICE = 1, // Invoice address
  DELIVERY = 2, // Delivery address
  TRANSACTION = 3, // Transaction address
  ADDITIONAL_DELIVERY = 4, // Additional delivery address
  ADDITIONAL_INVOICE = 5, // Additional invoice address
  PERIMETER_CENTER = 6 // Perimeter center address
}

export interface IContactAddress {
  /** Id of this contact address */
  contactAddressID: number;
  /** Address type */
  type: AddressType;
  /** Address related to this contactAddress */
  address: IAddress;
  /** Contact related to this contactAddress */
  contact: IContact;
  /** Member related to this contactAddress */
  member: IMember;
}

export interface IAddress {
  /** Id of this address */
  addressID: number;
  /** Street of this address */
  street: string;
  /** Additional information */
  info?: string;
  /** House number */
  houseNumber: string;
  /** Zip code */
  zip: string;
  /** City */
  city: string;
  /** Postbox code if sent to postbox */
  postbox?: string;
  /** Country */
  country: ICountry;
  /** Address type */
  type: AddressType;
  /** Longitude */
  longitude?: number;
  /** Latitude */
  latitude?: number;
  /** Display the address to the user in a predefined format  */
  displayName: string;
}

export interface ICountry {
  /** Country ID */
  countryID: number;
  /** Country ISO code like CH for switzerland */
  iSO: string;
  /** Country name in correct language */
  name: string;
}

export interface ISetCreateUpdateAddressResponse {
  /** Updated or created shipping address */
  shippingAddress: IPaginatedList<IContactAddress>;
  /** Updated or created invoice address */
  invoiceAddress: IPaginatedList<IContactAddress>;
  /** The rows with the totals for the checkout  */
  totalRows: ITotalRow[];
  /** Messages from the backend */
  results: IResult[];
  /** The basket related to this checkout-object */
  basket: IBasket;
}
